import { FC, Children, isValidElement } from "react";
import classNames from "classnames";
import { GroupProps as ExternalGroupProps } from "../Group";
import { Item, ItemProps } from "../Item";
import { LinkItem, LinkItemProps } from "../LinkItem";
import { ComponentItem, ComponentItemProps } from "../ComponentItem";
import { Item as ExternalItem } from "./Item";
import { LinkItem as ExternalLinkItem } from "./LinkItem";
import { ComponentItem as ExternalComponentItem } from "./ComponentItem";
import { MenuCloseEventHandler } from "../MenuCloseEventHandler";

import styles from "../styles.module.css";

/**
 * The `Item` component properties.
 */

export interface GroupProps extends ExternalGroupProps {
  /**
   * Called when an item in the group item has been clicked and is closing the menu.
   */
  readonly onClose?: MenuCloseEventHandler;
}

/**
 * The renderable menu group.
 */
export const Group: FC<GroupProps> = (props) => {
  const { label, onClose, children } = props;
  const groupLabelId = `group-label`;

  return (
    <section
      className={classNames(styles.Group, "group")}
      role="group"
      aria-labelledby={groupLabelId}
    >
      {label && <span id={groupLabelId} className={`${styles.header} header`}>{label}</span>}
      {Children.map(children, (child) => {
        if (!isValidElement(child)) return null;

        if (child.type === Item) {
          const itemProps = child.props as ItemProps;
          const { children } = itemProps;

          return (
            <ExternalItem {...itemProps} onClose={onClose}>
              {children}
            </ExternalItem>
          );
        } else if (child.type === LinkItem) {
          const itemProps = child.props as LinkItemProps;
          const { children } = itemProps;

          return (
            <ExternalLinkItem {...itemProps} onClose={onClose}>
              {children}
            </ExternalLinkItem>
          );
        } else if (child.type === ComponentItem) {
          const componentItemProps = child.props as ComponentItemProps;
          const { children } = componentItemProps;

          return <ExternalComponentItem {...componentItemProps}>{children}</ExternalComponentItem>;
        }
      })}
    </section>
  );
};
